/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import moment from "moment";

import {
  getDadosCriminais,
  getDadosCidadao,
  getDadosProcesso,
  getDadosOcorrencia,
  getDadosInquerito,
  getDadosInfracao,
  // getDadosMandadoPrisao,
  getFoto3x4,
} from "../../../services/apiConsultaCriminal";

import {
  IDadosPessoalCriminal,
  IDadosCriminais,
  IDadosProcessos,
  IDadosOcorrencias,
  IDadosInqueritos,
  IDadosInfracoes,
} from "../../../interface/criminal";

const styleInputs = {
  display: "flex",
  flexDirection: "row",
  gap: 1,
};

export const FichaCriminal: React.FC = () => {
  const history = useHistory();
  const [dadosCidadao, setdadosCidadao] = useState<IDadosPessoalCriminal[]>([]);
  const [dadosCriminal, setDadosCriminal] = useState<IDadosCriminais[]>([]);
  const [dadosProcesso, setDadosProcesso] = useState<IDadosProcessos[]>([]);
  const [dadosOcorrencia, setDadosOcorrencia] = useState<IDadosOcorrencias[]>(
    []
  );
  const [dadosInquerito, setDadosInquerito] = useState<IDadosInqueritos[]>([]);
  const [dadosInfracao, setDadosInfracao] = useState<IDadosInfracoes[]>([]);
  const [foto, setFoto] = useState("");
  const [msgError, setMsgErro] = useState("");

  const [loading, setLoading] = useState(true);
  const { params } = useRouteMatch<IDadosPessoalCriminal>();

  useEffect(() => {
    const foto3x4 = async () => {
      await getFoto3x4(params.NumeroPessoa).then((response) => {
        if (response.status === 200) {
          setFoto(response.data);
        }
        if (response.status === 404) {
          setMsgErro("Cadastro sem foto");
        }
        setLoading(false);
      });
    };
    const dadosCivil = async () => {
      await getDadosCidadao(params.NumeroPessoa).then((response) => {
        if (response.status === 200) {
          setdadosCidadao(response.data);
        }
        if (response.status === 404) {
          setMsgErro(
            "Não foi encontrado informações dessa ficha referente a este usuário"
          );
        }
        setLoading(false);
      });
    };
    const criminal = async () => {
      await getDadosCriminais(params.NumeroPessoa).then((response) => {
        if (response.status === 200) {
          setDadosCriminal(response.data);
        }
        if (response.status === 404) {
          setMsgErro(
            "Não foi encontrado informações dessa ficha referente a este usuário"
          );
        }
        setLoading(false);
      });
    };
    const processo = async () => {
      await getDadosProcesso(params.NumeroPessoa).then((response) => {
        if (response.status === 200) {
          setDadosProcesso(response.data);
        }
        if (response.status === 404) {
          setMsgErro(
            "Não foi encontrado informações dessa ficha referente a este usuário"
          );
        }
        setLoading(false);
      });
    };
    const ocorrencia = async () => {
      await getDadosOcorrencia(params.NumeroPessoa).then((response) => {
        if (response.status === 200) {
          setDadosOcorrencia(response.data);
        }
        if (response.status === 404) {
          setMsgErro(
            "Não foi encontrado informações dessa ficha referente a este usuário"
          );
        }
        setLoading(false);
      });
    };
    const inquerito = async () => {
      await getDadosInquerito(params.NumeroPessoa).then((response) => {
        if (response.status === 200) {
          setDadosInquerito(response.data);
        }
        if (response.status === 404) {
          setMsgErro(
            "Não foi encontrado informações dessa ficha referente a este usuário"
          );
        }
        setLoading(false);
      });
    };
    const infracao = async () => {
      await getDadosInfracao(params.NumeroPessoa).then((response) => {
        if (response.status === 200) {
          setDadosInfracao(response.data);
        }
        if (response.status === 404) {
          setMsgErro(
            "Não foi encontrado informações dessa ficha referente a este usuário"
          );
        }
        setLoading(false);
      });
    };

    foto3x4();
    dadosCivil();
    criminal();
    processo();
    ocorrencia();
    inquerito();
    infracao();
  }, []);

  const imprimir = () => {
    window.print();
  };

  const voltar = () => {
    history.goBack();
  };

  const theme = MUI.useTheme();
  // useEffect(() => {
  //   async function mandado() {
  //     await getDadosMandadoPrisao(params.NumeroPessoa).then((response) => {
  //       if (response.status === 200) {
  //         console.log(response.data)
  //       }

  //       if (response.status === 404) {
  //         setMsgErro('A busca não encontrou resultado ')
  //       }
  //     })
  //   }
  // })

  return (
    <MUI.Stack
      pt={[2, 0]}
      flexDirection="row"
      width="100%"
      height="80vh"
      overflow="auto"
      sx={{
        "@media print": {
          overflow: "hidden !important",
          height: "100%",
          pageBreakInside: "avoid",
        },
      }}
    >
      <MUI.Stack p={2} flex={1}>
        <MUI.Stack
          mb={1}
          gap={[1, 0]}
          width="100%"
          flexDirection={["column", "row"]}
          justifyContent="space-between"
          sx={{
            displayPrint: "none",
          }}
        >
          <MUI.Button
            variant="contained"
            startIcon={<Icon.KeyboardReturn />}
            onClick={voltar}
          >
            Voltar para pesquisa
          </MUI.Button>
          <MUI.Button variant="contained" onClick={imprimir}>
            Imprimir
          </MUI.Button>
        </MUI.Stack>

        {!loading ? (
          <>
            {foto && (
              <MUI.Stack height="16rem">
                <MUI.Avatar
                  imgProps={{
                    sx: {
                      width: "150px",
                      height: "200px",
                      objectFit: "fill",
                      "&:hover": {
                        width: "250px",
                        height: "270px",
                      },
                    },
                  }}
                  variant="rounded"
                  src={`data:image/jpeg;base64,${foto}`}
                  alt="imgCivil"
                  sx={{
                    width: "auto",
                    height: "265px",
                  }}
                />
              </MUI.Stack>
            )}

            {dadosCidadao &&
              dadosCidadao.map((usuario) => (
                <MUI.Stack
                  pb={2}
                  key={usuario.NumeroPessoa}
                  sx={{
                    "@media print": {
                      height: "100% !important",
                      pageBreakInside: "avoid",
                      mb: 1,
                    },
                  }}
                >
                  <MUI.Typography
                    bgcolor={theme.palette.secondary.light}
                    variant="h6"
                  >
                    Ficha Cadastro Civil
                  </MUI.Typography>
                  <MUI.Divider
                    sx={{
                      borderWidth: 1.5,
                      backgroundColor: `${theme.palette.secondary.contrastText}`,
                    }}
                  />
                  <MUI.Grid container spacing={1} py={1}>
                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Nome:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.Nome}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Mãe:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.Mae || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Pai:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.Pai || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Vulgo:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.vulgo || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Sexo:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.DescricaoSexo || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Data Nascimento:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {moment(usuario?.DataNascimentoAproximado).format(
                          "DD/MM/YYYY"
                        ) || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Número RG:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.RGAtribuido || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Data de Expedição:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {moment(usuario?.DataIdentificacao).format(
                          "DD/MM/YYYY"
                        ) || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Profissão:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.NomeProfissao || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Grau de Instrução:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.DescricaoGrauInstrucao || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Estado Civil:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.DescricaoEstadoCivil || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Número do CPF:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.CPF || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        País de Nascimento:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.NomePaisNascimento || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Nacionalidade:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.DescricaoNacionalidade || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Natural de:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.NomeMunicipioNascimento} /
                        {usuario.SiglaUFNascimento === "string"
                          ? usuario.SiglaUFNascimento
                          : "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Descrição tipo membro:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.DescricaoTipoMembro || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Antropometrias:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Antropometrias || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} md={12} sm={12} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Telefones:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Telefones || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} md={12} sm={12} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Documento apresentado:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario?.DocumentoApresentado || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} md={12} sm={12} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Endereço:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Enderecos || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Tem mandado:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.TemMandado === "0" ? "Não" : "Sim"}
                      </MUI.Typography>
                    </MUI.Grid>
                  </MUI.Grid>
                </MUI.Stack>
              ))}

            {(dadosCriminal &&
              dadosCriminal.map((usuario) => (
                <MUI.Stack
                  key={usuario.NumeroPessoa}
                  sx={{
                    "@media print": {
                      my: 1,
                      height: "40%",
                      pageBreakInside: "avoid",
                    },
                  }}
                >
                  <MUI.Typography
                    bgcolor={theme.palette.secondary.light}
                    variant="h6"
                  >
                    Dados Criminal
                  </MUI.Typography>
                  <MUI.Divider
                    sx={{
                      borderWidth: 1.5,
                      backgroundColor: `${theme.palette.secondary.contrastText}`,
                    }}
                  />
                  <MUI.Grid container spacing={1} py={1}>
                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        RC:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.RC}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Flagrante:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Flagrante === "0" ? "Não" : "Sim"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Anota:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Anota}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Tem porte de arma:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.TemPorteArma === "0" ? "Não" : "Sim"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Nome tipo policial:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.NomeTipoPolicial || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Tipo policial:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.TipoPolicial || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Documento:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Documento || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>
                  </MUI.Grid>
                </MUI.Stack>
              ))) || <MUI.Typography variant="h6">{msgError}</MUI.Typography>}

            {(dadosProcesso &&
              dadosProcesso.map((usuario) => (
                <MUI.Stack
                  key={usuario.NumeroPessoa}
                  sx={{
                    "@media print": {
                      my: 1,
                      pageBreakInside: "avoid",
                    },
                  }}
                >
                  <MUI.Typography
                    bgcolor={theme.palette.secondary.light}
                    variant="h6"
                  >
                    Dados do Processo
                  </MUI.Typography>
                  <MUI.Divider
                    sx={{
                      borderWidth: 1.5,
                      backgroundColor: `${theme.palette.secondary.contrastText}`,
                    }}
                  />
                  <MUI.Grid container spacing={1} py={1}>
                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        RC:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.RC || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Número:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Numero || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Nome do orgão:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.NomeOrgao || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Nome orgão simples:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.NomeOrgaoSimples || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Obs :
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.OBS === "string"
                          ? usuario.OBS
                          : "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Status da descrição:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.DescricaoStatus || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Munícipio do orgão:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.NomeMunicipioOrgao || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        UF do orgão:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.SiglaUFOrgao || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Descrição do resultado:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.DescricaoResultado || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>
                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Data da atualização:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {moment(usuario.DataAtualizacao).format("DD/MM/YYYY") ||
                          "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>
                  </MUI.Grid>
                </MUI.Stack>
              ))) || <MUI.Typography variant="h6">{msgError}</MUI.Typography>}

            {(dadosOcorrencia &&
              dadosOcorrencia.map((usuario) => (
                <MUI.Stack
                  key={usuario.NumeroPessoa}
                  sx={{
                    "@media print": {
                      my: 1,
                      pageBreakInside: "avoid",
                    },
                  }}
                >
                  <MUI.Typography
                    bgcolor={theme.palette.secondary.light}
                    variant="h6"
                  >
                    Dados da ocorrência
                  </MUI.Typography>
                  <MUI.Divider
                    sx={{
                      borderWidth: 1.5,
                      backgroundColor: `${theme.palette.secondary.contrastText}`,
                    }}
                  />
                  <MUI.Grid container spacing={1} py={1}>
                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        RC:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.RC || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Número do inquérito:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.NumeroInquerito || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Data da abertura do inquérito:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {moment(usuario.DataAberturaInquerito).format(
                          "DD/MM/YYYY"
                        )}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Data do fato:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {moment(usuario.DataFato).format("DD/MM/YYYY") ||
                          "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Hora do fato :
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.HoraFatoVazia || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Flagrante:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Flagrante === "0" ? "Não" : "Sim"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Vítimas:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Vitimas || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Local:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Local || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>
                  </MUI.Grid>
                </MUI.Stack>
              ))) || <MUI.Typography variant="h6">{msgError}</MUI.Typography>}

            {(dadosInquerito &&
              dadosInquerito.map((usuario) => (
                <MUI.Stack
                  key={usuario.NumeroPessoa}
                  sx={{
                    "@media print": {
                      mt: 2,
                      mb: 1,
                      pageBreakInside: "avoid",
                    },
                  }}
                >
                  <MUI.Typography
                    bgcolor={theme.palette.secondary.light}
                    variant="h6"
                  >
                    Dados do inquérito
                  </MUI.Typography>
                  <MUI.Divider
                    sx={{
                      borderWidth: 1.5,
                      backgroundColor: `${theme.palette.secondary.contrastText}`,
                    }}
                  />
                  <MUI.Grid container spacing={1} py={1}>
                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        RC:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.RC || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Número do inquérito:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Numero || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Nome do documento:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.NomeDocumento || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Mnemônico:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.MnemonicoDocumento || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Nome do orgão:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.NomeOrgao || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Munícipio do orgão:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.NomeMunicipioOrgao || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        UF do orgão:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.SiglaUFOrgao || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Data da abertura do inquérito:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {moment(usuario.DataAberturaInquerito).format(
                          "DD/MM/YYYY"
                        ) || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Data da conclusão:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {moment(usuario.DataConclusao).format("DD/MM/YYYY") ||
                          "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Presidente do processo:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.NomePresidenteProcesso || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Status da descrição:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.DescricaoStatus || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Data do indiciamento:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {moment(usuario.DataIndiciamento).format(
                          "DD/MM/YYYY"
                        ) || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Data fim do indiciamento:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {moment(usuario.DataFimIndiciamento).format(
                          "DD/MM/YYYY"
                        ) || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Status descrição individual:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.DescricaoStatusIndividual || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Data da última atualização:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {moment(usuario.DataUltimaAtualizacao).format(
                          "DD/MM/YYYY"
                        ) || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>

                    <MUI.Grid xs={12} md={12} sm={12} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Obs do inquérito individual:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.OBSInqueritoIndividual || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>
                  </MUI.Grid>
                </MUI.Stack>
              ))) || <MUI.Typography variant="h6">{msgError}</MUI.Typography>}

            {(dadosInfracao &&
              dadosInfracao.map((usuario) => (
                <MUI.Stack
                  key={usuario.NumeroPessoa}
                  sx={{
                    "@media print": {
                      my: 1,
                      pageBreakInside: "avoid",
                    },
                  }}
                >
                  <MUI.Typography
                    bgcolor={theme.palette.secondary.light}
                    variant="h6"
                  >
                    Dados da infração
                  </MUI.Typography>
                  <MUI.Divider
                    sx={{
                      borderWidth: 1.5,
                      backgroundColor: `${theme.palette.secondary.contrastText}`,
                    }}
                  />
                  <MUI.Grid container spacing={1} py={1}>
                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        RC:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.RC || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>
                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <MUI.Typography fontWeight="bold" variant="body1">
                        Infração:
                      </MUI.Typography>
                      <MUI.Typography variant="body1">
                        {usuario.Infracao || "Não informado"}
                      </MUI.Typography>
                    </MUI.Grid>
                  </MUI.Grid>
                </MUI.Stack>
              ))) || <MUI.Typography variant="h6">{msgError}</MUI.Typography>}
          </>
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </MUI.Stack>
  );
};
